export { default } from './RepArtistCard';
